import { Scene, Vector2, type Texture, type IUniform } from 'three';

export interface AnnotationLayer {
  readonly scene: Scene;
  readonly depth: IUniform<Texture | null>;
  readonly resolution: IUniform<Vector2>;
}

export function createAnnotationLayer(): AnnotationLayer {
  return { scene: new Scene(), depth: { value: null }, resolution: { value: new Vector2(1, 1) } };
}
